import { render } from "./ImageBrowser.vue?vue&type=template&id=bd33fb5e&scoped=true"
import script from "./ImageBrowser.vue?vue&type=script&lang=js"
export * from "./ImageBrowser.vue?vue&type=script&lang=js"

import "./ImageBrowser.vue?vue&type=style&index=0&id=bd33fb5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd33fb5e"]])

export default __exports__